import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  inputLabel: {
    fontSize: 12,
    marginTop: 15,
  },
  buttonAnalysis: {
    height: 36,
    width: 36,
    minWidth: 36,
  },
  buttonDisabled: {
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    color: 'rgba(0, 0, 0, 0.20)',
  },
  buttonPublish: {
    backgroundColor: 'black',
    color: 'white',
  },
  buttonReject: {
    backgroundColor: '#ffda6a',
    color: '#443a18',
    '&:hover': {
      backgroundColor: '#443a18',
      color: '#ffda6a',
    },
  },
  swalDialog: {
    zIndex: 1350,
  },
  buttonSave: {
    backgroundColor: 'gray',
    color: 'white',
  },
}));
